<header>
        <h1 class="site-heading text-center text-faded d-none d-lg-block intro" >
            <span class="site-heading-upper fw-bold mb-3" style="color: #e6a756;">DWWM7 & CDA7</span>
            <span class="site-heading-lower">AFPA 2021</span>
        </h1>
</header>